import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

interface LinkButtonProps {
  buttonText: string;
  handleClick: any;
  overrideStyles?: any;
}
export function LinkButton({
  buttonText,
  handleClick,
  overrideStyles
}: LinkButtonProps) {
  return (
    <Button
      color="inherit"
      style={{
        padding: '10px 30px 10px 30px',
        color: '#010d0d',
        border: 'solid 2px #010d0d',
        borderRadius: 30,
        fontSize: '20px',
        backgroundColor: 'transparent',
        ...overrideStyles
      }}
      onClick={handleClick}
    >
      <Typography variant="h6">{buttonText}</Typography>
    </Button>
  );
}
